// extracted by mini-css-extract-plugin
export default {"adminSearch":"AdminBucketSearch_adminSearch__oZI4d"};